'use client';

import useSWR from 'swr';
import { myPlannerApi } from './my-planner.api';
import type { PlannerCounselSlotResponse } from './planner-counsel-slot.api';

const VALID_STATUSES = new Set(['APPOINTED', 'AVAILABLE']);

async function fetchMyAssignedRegionIds(date: string): Promise<string[]> {
  const regionSlots = await myPlannerApi.getMySlotsByDate(date);
  const ids = new Set<string>();
  for (const region of regionSlots as PlannerCounselSlotResponse[]) {
    if (!region.regionId) continue;
    const hasValidSlot = region.slots?.some((s) => VALID_STATUSES.has(s.status));
    if (hasValidSlot) ids.add(region.regionId);
  }
  return Array.from(ids);
}

/**
 * PLANNER 전용: 현재 플래너의 특정 날짜 근무 배정 구역 ID 목록
 * /api/v1/planners/me/visit-counsels/slots 사용
 */
export function useMyPlannerDayAssignedRegionIds(
  date: string,
  enabled = true
): { regionIds: string[]; isLoading: boolean; error: Error | null } {
  const { data, error, isLoading } = useSWR<string[]>(
    enabled && date ? ['my-planner-day-assigned-regions', date] : null,
    () => fetchMyAssignedRegionIds(date),
    { revalidateOnMount: true }
  );

  return {
    regionIds: data ?? [],
    isLoading,
    error: error ? (error instanceof Error ? error : new Error(String(error))) : null,
  };
}
